// Generated by CoffeeScript 2.7.0
var UserProfile;

import Schema from './schema.js';

export default UserProfile = {Schema};
